// extracted by mini-css-extract-plugin
module.exports = {"moneyCell__text":"styles_moneyCell__text__3v0lE","negative":"styles_negative__3cMiH","positive":"styles_positive__1D82q"};